import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faHome } from '@fortawesome/free-solid-svg-icons';

interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <nav className="flex items-center space-x-1 text-xs mb-2">
      <button
        onClick={() => items[0]?.onClick?.()}
        className="text-gray-400 hover:text-gray-600 transition-colors text-xs"
        title="Home"
      >
        <FontAwesomeIcon icon={faHome} />
      </button>

      {items.map((item, index) => (
        <React.Fragment key={index}>
          <FontAwesomeIcon icon={faChevronRight} className="text-gray-300 text-xs" />
          {item.onClick && index < items.length - 1 ? (
            <button
              onClick={item.onClick}
              className="text-blue-600 hover:text-blue-800 transition-colors text-xs"
            >
              {item.label}
            </button>
          ) : (
            <span className={index === items.length - 1 ? 'text-gray-900 font-medium text-xs' : 'text-gray-500 text-xs'}>
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};
